import 'whatwg-fetch'
export const getFundDetails = async (fundId, fundClassId, lang, fundDetailItem) => {
  const fundDetails = {}
  let fund
  if (fundDetailItem == undefined || fundDetailItem == null) {
    fund = await getFundDetailsByFundClass(fundId, fundClassId, lang)
  }
  else {
    fund = fundDetailItem
    //console.log(fundDetailItem)
    fundDetailItem = null
  }
  let entries = ''
  fund.entries.forEach((entry) => {
    const entryTemplate = `
    <div class="col-8 col-sm-4  mwr-1 cmp-fund-list__fund-container__fund-item">
        <div class="cmp-fund-list__fund-container__fund-item__title">
            ${entry.title}
        </div>
        <div class="cmp-fund-list__fund-container__fund-item__entry">
            ${entry.name ? entry.name : ''}
        </div>
        <div class="cmp-fund-list__fund-container__fund-item__disclaimer">
            ${entry.disclaimer ? entry.disclaimer : ''}
        </div>
    </div>`

    entries += entryTemplate
  })
  fundDetails.entries = entries

  let quickLinks = ''
  fund.quickLinks.forEach((link) => {
    let target = '_blank'
    //let target = '_self'
    if (link.id == 'kiid') {
      target = '_self'
    }
    quickLinks += `<a class="cta-link text-green-400" target="` + target + `" href="${link.href}">${link.text}</a>`
  })

  fundDetails.quickLinks = quickLinks

  let managers = ''
  if (fund && fund.moreInfo && fund.moreInfo.managers) {
    fund.moreInfo.managers.forEach((manager) => {
      managers += `<div><a href='${manager.url}'>${manager.name}</a></div>`
    })
  }

  fundDetails.managers = managers

  if (fund && fund.moreInfo && fund.moreInfo.objective) {
    fundDetails.objective = fund.moreInfo.objective
  }

  fundDetails.fundDetailPage = fund.fundDetailPage
  fundDetails.quickLinksLabel = fund.quickLinksLabel
  fundDetails.moreLabel = fund.moreLabel
  fundDetails.lessLabel = fund.lessLabel
  fundDetails.managersLabel = fund.managersLabel
  fundDetails.objectiveLabel = fund.objectiveLabel
  fundDetails.isin = fund.isin

  return fundDetails
}

async function getFundDetailsByFundClass(fundId, fundClassId, language) {
  let apiURL = ''
  if (window.location.hostname !== 'localhost') {
    apiURL = '/api/funddetail/'
  }
  let url = ''
  const baseUrl = apiURL + fundId + '?lang=' + language.toLowerCase()
  if (fundClassId) {
    url = baseUrl + '&classid=' + fundClassId
  } else {
    url = baseUrl
  }

  const response = await window.fetch(url)
  const data = await response.json()
  return data.JsonContent
}
